import React from "react";

import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

const useStyles = makeStyles(({ breakpoints, spacing }) => ({
  root: (props) => ({
    display: props.container ? "grid" : undefined,
    gridTemplateColumns: props.container
      ? `repeat(${props.columns}, 1fr)`
      : undefined,
    gridColumnGap:
      typeof props.columnGap === "number"
        ? spacing(props.columnGap)
        : undefined,
    gridRowGap:
      typeof props.rowGap === "number" ? spacing(props.rowGap) : undefined,
    gridColumn: props.item ? `span ${props.xs}` : undefined,
    [breakpoints.up("xs")]: breakpointProps("xs", props, spacing),
    [breakpoints.up("sm")]: breakpointProps("sm", props, spacing),
    [breakpoints.up("md")]: breakpointProps("md", props, spacing),
    [breakpoints.up("lg")]: breakpointProps("lg", props, spacing),
    [breakpoints.up("xl")]: breakpointProps("xl", props, spacing),
  }),
}));

function breakpointProps(breakpoint, props, spacing) {
  return {
    gridColumn:
      props.item && props[breakpoint] ? `span ${props[breakpoint]}` : undefined,
    gridColumnGap:
      typeof props.rowGap === "object"
        ? spacing(props.rowGap[breakpoint])
        : undefined,
    gridRowGap:
      typeof props.rowGap === "object"
        ? spacing(props.rowGap[breakpoint])
        : undefined,
  };
}

const RbGrid = React.forwardRef(function RbGrid(props, ref) {
  const {
    children,
    component: Component,
    container,
    item,
    columnGap,
    rowGap,
    ...other
  } = props;

  const classes = useStyles(props);

  return (
    <Component {...other} ref={ref} className={classes.root}>
      {children}
    </Component>
  );
});

RbGrid.propTypes = {
  children: PropTypes.node,
  columnGap: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      xs: PropTypes.number,
      sm: PropTypes.number,
      md: PropTypes.number,
      lg: PropTypes.number,
      xl: PropTypes.number,
    }),
  ]),
  columns: PropTypes.number,
  component: PropTypes.elementType,
  container: PropTypes.bool,
  item: PropTypes.bool,
  rowGap: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.shape({
      xs: PropTypes.number,
      sm: PropTypes.number,
      md: PropTypes.number,
      lg: PropTypes.number,
      xl: PropTypes.number,
    }),
  ]),
  xs: PropTypes.number,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
};

RbGrid.defaultProps = {
  columns: 12,
  component: Box,
  xs: 1,
  children: null,
  columnGap: undefined,
  container: undefined,
  item: undefined,
  rowGap: undefined,
  sm: undefined,
  md: undefined,
  lg: undefined,
  xl: undefined,
};

export default RbGrid;
